<template>
    <nav class="pb-safe fixed inset-x-0 bottom-0 z-50 bg-white shadow-[0_-4px_12px_rgba(0,0,0,0.08)]">
        <div class="flex h-14 items-center justify-around">
            <router-link
                v-for="item in navigationItems"
                :key="item.route"
                v-slot="{ isActive }"
                :to="{ path: item.route }"
                class="flex flex-1 flex-col items-center justify-center py-2"
            >
                <div class="relative flex flex-col items-center">
                    <SvgIcon
                        :name="isActive ? getFilledIcon(item.icon) : item.icon"
                        class="size-6 transition-colors"
                        :class="isActive ? 'text-brand' : 'text-muval-gray-2'"
                    />
                    <div
                        class="mt-1.5 h-0.5 w-2 rounded-full transition-colors"
                        :class="isActive ? 'bg-brand' : 'bg-transparent'"
                    />
                </div>
            </router-link>
        </div>
    </nav>
</template>

<script setup>
const userStore = useUserStore();

const navigationItems = computed(() => {
    return userStore.navigation || [];
});

function getFilledIcon(icon) {
    // Map outline icons to their filled equivalents
    if (icon.includes('-outline')) {
        return icon.replace('-outline', '-filled');
    }
    // For icons without outline/filled naming, return as-is
    return icon;
}
</script>

<style scoped>
.pb-safe {
    padding-bottom: env(safe-area-inset-bottom, 0px);
}
</style>
